module.exports = __webpack_public_path__ + "img/caseTitle.d5f6d76a.png";